import { postDataAPI } from "../../utils/fetchData";
import valid from "../../utils/valid";
import { GLOBALTYPES } from "./globalTypes";

export const TYPES = {
	AUTH: "AUTH",
};

// Helper function for common alert dispatch
const dispatchAlert = (dispatch, payload) => {
	dispatch({ type: GLOBALTYPES.ALERT, payload });
};

// Helper function for common auth dispatch
const dispatchAuth = (dispatch, token, user) => {
	dispatch({
		type: GLOBALTYPES.AUTH,
		payload: {
			token,
			user,
			isHydrated: true,
		},
	});

	dispatch({
		type: GLOBALTYPES.USER_TYPE,
		payload: user.role,
	});
};

// Helper function for redirect logic
// const handleRedirect = (redirectUrl) => {
// 	if (redirectUrl) {
// 		localStorage.removeItem("redirectAfterLogin");
// 		console.log("Redirecting to:", redirectUrl);
// 		window.location.href = redirectUrl;
// 	} else {
// 		console.log("No redirect URL found, going to default courses page");
// 		window.location.href = "./courses/9ae8b71c-dd3f-4fad-b1ee-e872f951e7af";
// 	}
// };

// Helper function for password validation
const validatePasswordChange = (oldPassword, newPassword, cnfNewPassword) => {
	const errors = [];

	if (!oldPassword?.trim()) {
		errors.push("Please enter your old password.");
	}
	if (!newPassword?.trim()) {
		errors.push("Please enter your new password.");
	}
	if (!cnfNewPassword?.trim()) {
		errors.push("Please confirm your new password.");
	}
	if (newPassword !== cnfNewPassword) {
		errors.push("Your password does not match");
	}

	return errors;
};

export const login = (data) => async (dispatch) => {
	try {
		dispatchAlert(dispatch, { loading: true });

		const res = await postDataAPI("login", data);
		console.log("login res", res.data);

		const { access_token, user, msg } = res.data;

		dispatchAuth(dispatch, access_token, user);

		localStorage.setItem("firstLogin", true);
		localStorage.setItem("access_token", access_token);

		// const redirectUrl = localStorage.getItem("redirectAfterLogin");
		// handleRedirect(redirectUrl);

		dispatchAlert(dispatch, { success: msg });
	} catch (err) {
		if (!err.isCanceled) {
			const errorMsg =
				err.response?.data?.msg || "Login failed. Please try again.";
			dispatchAlert(dispatch, { error: errorMsg });
		}
	}
};

export const resetPasswordRequest = (data) => async (dispatch) => {
	try {
		dispatchAlert(dispatch, { loading: true });

		const res = await postDataAPI("resetPasswordRequest", data);
		console.log("reset password request", res.data);

		dispatchAlert(dispatch, { success: res.data.msg });

		// Use setTimeout with proper cleanup
		const timeoutId = setTimeout(() => {
			window.location.reload();
		}, 1000);

		// Cleanup timeout if component unmounts
		return () => clearTimeout(timeoutId);
	} catch (err) {
		if (!err.isCanceled) {
			const errorMsg =
				err.response?.data?.msg || "Password reset request failed.";
			dispatchAlert(dispatch, { error: errorMsg });
		}
	}
};

export const resetPassword =
	({ password, token, user }) =>
	async (dispatch) => {
		try {
			dispatchAlert(dispatch, { loading: true });

			const res = await postDataAPI(
				"resetPassword",
				{ password, id: user.id },
				token
			);
			console.log("reset password", res.data);

			dispatchAlert(dispatch, { success: res.data.msg });

			const timeoutId = setTimeout(() => {
				window.location.href = "/login";
			}, 1000);

			return () => clearTimeout(timeoutId);
		} catch (err) {
			if (!err.isCanceled) {
				const errorMsg = err.response?.data?.msg || "Password reset failed.";
				dispatchAlert(dispatch, { error: errorMsg });
			}
		}
	};

export const changePassword =
	({ oldPassword, newPassword, cnfNewPassword, auth }) =>
	async (dispatch) => {
		// Validate inputs first
		const validationErrors = validatePasswordChange(
			oldPassword,
			newPassword,
			cnfNewPassword
		);

		if (validationErrors.length > 0) {
			validationErrors.forEach((error) => {
				dispatchAlert(dispatch, { error });
			});
			return;
		}

		try {
			dispatchAlert(dispatch, { loading: true });

			const res = await postDataAPI(
				"changePassword",
				{ oldPassword, newPassword },
				auth.token
			);

			dispatchAlert(dispatch, { loading: false });
			dispatchAlert(dispatch, { success: res.data.msg });
		} catch (err) {
			if (!err.isCanceled) {
				dispatchAlert(dispatch, { loading: false });
				const errorMsg = err.response?.data?.msg || "Password change failed.";
				dispatchAlert(dispatch, { error: errorMsg });
			}
		}
	};

export const adminLogin = (data) => async (dispatch) => {
	try {
		dispatchAlert(dispatch, { loading: true });

		const res = await postDataAPI("admin_login", data);
		const { access_token, user, msg } = res.data;

		dispatchAuth(dispatch, access_token, user);

		localStorage.setItem("firstLogin", true);

		const redirectUrl = localStorage.getItem("redirectAfterLogin");
		if (redirectUrl) {
			localStorage.removeItem("redirectAfterLogin");
			console.log("Admin redirecting to:", redirectUrl);
			window.location.href = redirectUrl;
		} else {
			console.log("No redirect URL found, admin going to default courses page");
			window.location.href = "./courses/9ae8b71c-dd3f-4fad-b1ee-e872f951e7af";
		}

		dispatchAlert(dispatch, { success: msg });
	} catch (err) {
		if (!err.isCanceled) {
			const errorMsg = err.response?.data?.msg || "Admin login failed.";
			dispatchAlert(dispatch, { error: errorMsg });
		}
	}
};

export const refreshToken = () => async (dispatch) => {
	const firstLogin = localStorage.getItem("firstLogin");
	const access_token = localStorage.getItem("access_token");

	if (!firstLogin || !access_token) {
		return;
	}

	try {
		dispatchAlert(dispatch, { loading: true });

		const res = await postDataAPI("refresh_token", {}, access_token);
		const { access_token: newToken, user } = res.data;

		dispatchAuth(dispatch, newToken, user);
		dispatchAlert(dispatch, {});
	} catch (err) {
		if (!err.isCanceled) {
			dispatchAlert(dispatch, { loading: false });
			console.log("Token refresh failed:", err.response?.data);

			// Clear invalid tokens
			localStorage.removeItem("firstLogin");
			localStorage.removeItem("access_token");
		}
	}
};

export const register = (data) => async (dispatch) => {
	try {
		dispatchAlert(dispatch, { loading: true });

		const res = await postDataAPI("register", data);
		console.log("register res", res.data);

		dispatchAlert(dispatch, { loading: false });
		dispatchAlert(dispatch, { success: res.data.msg });
	} catch (err) {
		if (!err.isCanceled) {
			dispatchAlert(dispatch, { loading: false });
			const errorMsg = err.response?.data?.msg || "Registration failed.";
			dispatchAlert(dispatch, { error: errorMsg });
		}
	}
};

export const registerAdmin = (data) => async (dispatch) => {
	const check = valid(data);
	if (check.errLength > 0) {
		return dispatch({ type: GLOBALTYPES.ALERT, payload: check.errMsg });
	}

	try {
		dispatchAlert(dispatch, { loading: true });

		const res = await postDataAPI("register_admin", data);

		dispatchAlert(dispatch, { success: res.data.msg });
	} catch (err) {
		if (!err.isCanceled) {
			const errorMsg = err.response?.data?.msg || "Admin registration failed.";
			dispatchAlert(dispatch, { error: errorMsg });
		}
	}
};

export const logout = () => async (dispatch) => {
	try {
		// Clear local storage first
		localStorage.removeItem("instructor");
		localStorage.removeItem("firstLogin");
		localStorage.removeItem("access_token");

		// Attempt to call logout API (but don't fail if it doesn't work)
		try {
			await postDataAPI("logout");
		} catch (apiError) {
			console.warn(
				"Logout API call failed, but continuing with logout:",
				apiError
			);
		}

		window.location.href = "/login";
	} catch (err) {
		if (!err.isCanceled) {
			const errorMsg = err.response?.data?.msg || "Logout failed.";
			dispatchAlert(dispatch, { error: errorMsg });
		}
	}
};
